import { Button, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconPhone } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';
import type { Phone } from 'types/storeTypes';

type DirectContactCallProps = {
  phones: Phone[];
  onConfirm: () => void;
};

export const DirectContactCall = ({ phones, onConfirm }: DirectContactCallProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <Stack gap="xs">
        {phones.map(phone => (
          <Group key={phone.id} gap="sm">
            <ThemeIcon variant="light" radius="xl">
              <IconPhone size={18} />
            </ThemeIcon>
            <Stack gap={0}>
              <Text fw={700}>{phone.number}</Text>
              <Text size="xs" c="dimmed">
                {phone.type}
              </Text>
            </Stack>
          </Group>
        ))}
      </Stack>
      <Group justify="flex-end">
        <Button onClick={onConfirm}>
          {t(tKeys.MODULES.AT_RISK.DIRECT_CONTACT.PAUSE_AFTER_CALL)}
        </Button>
      </Group>
    </Stack>
  );
};
